<template>
  <van-nav-bar
    :style="bannerStyle"
    :class="[
      'lld-rewrite-am-navbar-light',
      { 'back-banner-fixed': isFixed },
      not_iphonex ? 'notrem-lld-rewrite-am-navbar-light-notiphonex' : '',
      iphonex && !not_iphonex
        ? 'notrem-lld-rewrite-am-navbar-light-iphonex'
        : '',
    ]"
    :title="title"
    :left-arrow="defaultGoBack"
    @click-left="bannerGoBack"
  />
</template>

<script>
export default {
  name: "BackBanner",
  data() {
    return {
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    isFixed: {
      type: Boolean,
      default: true,
    },
    defaultGoBack: {
      type: Boolean,
      default: true,
    },
    barOpacity: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    bannerGoBack() {
      this.$emit("goBack");
    },
  },
  computed: {
    bannerStyle() {
      let baseStyle = {
        opacity: this.barOpacity,
      };
      return baseStyle;
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style scoped lang="scss">
.back-banner-fixed {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  // box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
}
.lld-rewrite-am-navbar-light {
  color: #333;
  height: 33px;
  box-sizing: content-box;
}
.notrem-lld-rewrite-am-navbar-light-iphonex {
  padding-top: 30px;
}
.notrem-lld-rewrite-am-navbar-light-notiphonex {
  padding-top: 15px;
}
.van-hairline--bottom::after {
  border: none;
}
::v-deep .van-nav-bar__content {
  height: 100%;
}
::v-deep .van-nav-bar__title {
  font-size: 13px;
  font-weight: 600;
}
::v-deep .van-nav-bar__left > .van-nav-bar__arrow {
  font-size: 16px !important;
  top: 0 !important;
  left: -4px !important;
}
</style>
